var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.solotexto)?_c('v-chip',{attrs:{"color":_vm.getColor(_vm.estado.id_estado),"dark":""}},[_vm._v(_vm._s(_vm.estado.descripcion_estado))]):_vm._e(),(_vm.solotexto)?_c('span',[_vm._v(_vm._s(_vm.estado.descripcion_estado))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }